var React = require('react');

function Building (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Page 1"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("path",{"d":"M5.37509228,0 L0,3.49593958 L0,11.2476574 L5.49860867,15 L10.7339997,11.2433983 L10.7339997,3.63393719 L5.37509228,0 Z M1.87915271,3.94911693 L5.35890738,1.68493384 L8.78329263,4.00704185 L5.44409109,6.30529843 L1.87915271,3.94911693 Z","fill":"#C1C6D6"}))]);
}

Building.defaultProps = {"width":"11px","height":"15px","viewBox":"0 0 11 15","version":"1.1"};

module.exports = Building;

Building.default = Building;
